import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { TitleBarModule, LoadingErrorModule, PipesModule, SpinnerModule, DfMonthPickerModule, StoreProviderModule, MenuModule, ExceptionsModule, NgbCompatModule } from '@uxdf/direct-shared-lib';
import { LoyaltyAgentsParticipationComponent } from './loyalty-agents-participation/loyalty-agents-participation.component';
import { LoyaltyBonusPointsComponent } from './loyalty-bonus-points/loyalty-bonus-points.component';
import { LoyaltyHomepageTooltipComponent } from './loyalty-homepage-tooltip/loyalty-homepage-tooltip.component';
import { LoyaltyEnrollNowComponent } from './loyalty-program-enrollment/loyalty-enroll-now/loyalty-enroll-now.component';
import { LoyaltyFinishFormComponent } from './loyalty-program-enrollment/loyalty-finish-form/loyalty-finish-form.component';
import { LoyaltyProgramEnrollmentComponent } from './loyalty-program-enrollment/loyalty-program-enrollment.component';
import { LoyaltyStatusPointsComponent } from './loyalty-status-points/loyalty-status-points.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoyaltyLoginFormComponent } from './loyalty-program-enrollment/loyalty-login-form/loyalty-login-form.component';
import { ReefI18nModule, ReefAppModule } from '@seco/core';
import { FormGroupModule, NavbarModule, ConfirmAlertModule } from '@uxdf/p-components';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DfSelectModule, DfMediaModule, DfAlertModule, DfDatePickerModule } from '@design-factory/design-factory';
import { CsvModule } from '@ctrl/ngx-csv';
import { AnalyticsModule } from '@seco/dev-utils';
import { DoughnutChartModule } from '../../directives/doughnutChart.module';

@NgModule({
  declarations: [LoyaltyAgentsParticipationComponent,
    LoyaltyBonusPointsComponent,
    LoyaltyHomepageTooltipComponent,
    LoyaltyEnrollNowComponent,
    LoyaltyFinishFormComponent,
    LoyaltyProgramEnrollmentComponent,
    LoyaltyStatusPointsComponent,
    LoyaltyLoginFormComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TitleBarModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingErrorModule,
    NgbCompatModule,
    PipesModule,
    FormGroupModule,
    SpinnerModule,
    NgSelectModule,
    ReefI18nModule,
    NgSelectModule,
    SpinnerModule,
    DfMonthPickerModule,
    FeatureToggleModule,
    NgxPermissionsModule.forRoot(),
    NavbarModule,
    ConfirmAlertModule,
    NgxPageScrollModule,
    StoreProviderModule,
    MenuModule,
    ExceptionsModule,
    DfSelectModule,
    DfDatePickerModule,
    CsvModule,
    DfMediaModule,
    ReefAppModule.forRoot(),
    AnalyticsModule,
    DoughnutChartModule,
    DfAlertModule
  ]
})
export class LoyaltyModule {}
